<div class="text-container">
  <div class="text-container__inner">
    <div class="text-container__title">{{ text | translate }}</div>
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
</div>
